import React from 'react';

import {
  ArrayField,
  TextField,
  usePermissions,
} from 'react-admin';

import {
  Box,
  Typography,
  CardContent,
} from '@mui/material';

import ReferenceEntityField from '../../customFields/ReferenceEntityField';

import DeleteEntities from '../case/components/DeleteEntities';
import EntityDisplayNameField from '../../customFields/EntityDisplayNameField';
import ColoredScoreField from '../../customFields/ColoredScoreField';
import RiskClassField from '../../customFields/RiskClassField';
import EntityTypeAvatarField from '../../customFields/EntityTypeAvatarField';
import ShowEntityButton from './ShowEntityButton';
import CurrencyCardKPIDatagrid from './CurrencyCardKPIDatagrid';
import GroupsDialogEditField from './GroupsDialogEditField';
import QuickView from './QuickView';
import hasAccess from '../../utilities/hasAccess';
import actions, { Actions } from '../../constants/actions';

const EntityCardContent = ({ caseId }: { caseId: string }) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <CardContent>
      <Box display="flex" marginBottom={4} justifyContent="space-between" alignItems="flex-start">
        <Box display="flex" gap={2}>
          <EntityTypeAvatarField />
          <Box display="flex" flexDirection="column">
            <TextField source="type" />
            <ReferenceEntityField source="" linkType={false}>
              <EntityDisplayNameField />
            </ReferenceEntityField>
          </Box>
        </Box>
        <Box display="flex">
          <QuickView caseId={caseId} />
          <ShowEntityButton label="Go to entity" />
          <DeleteEntities onlyIcon />
        </Box>
      </Box>
      <Box display="flex" gap={3}>
        <Box display="flex" gap={1}>
          <Typography variant="label" fontSize={13}>Risk score:</Typography>
          <ReferenceEntityField source="" linkType={false}>
            <ColoredScoreField source="riskScore" />
          </ReferenceEntityField>
        </Box>
        <Box display="flex" gap={1}>
          <Typography variant="label" fontSize={13}>Risk class:</Typography>
          <ReferenceEntityField source="" linkType={false}>
            <RiskClassField source="riskScore" />
          </ReferenceEntityField>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" marginTop={4}>
        <ReferenceEntityField source="" linkType={false}>
          <GroupsDialogEditField />
        </ReferenceEntityField>
      </Box>
      {hasAccess(permissions, actions.REQUEST_GET) && (
        <ReferenceEntityField source="" linkType={false}>
          <ArrayField source="currencies">
            <CurrencyCardKPIDatagrid />
          </ArrayField>
        </ReferenceEntityField>
      )}
    </CardContent>
  );
};

export default EntityCardContent;
